import { ComponentInstance } from '@sapappgyver/appgyver-descriptors/lib/dolan/v4';

export default function getNestedStyleOverridesQueryKey(component: ComponentInstance, isRoot: boolean): string {
  if (isRoot) {
    return `${component?.name}-root`;
  }
  if (typeof component.id === 'string') {
    return `*-${component.id.split('-').pop()}`;
  }
  return '';
}
